import { gql } from 'urql';

const CompleteBottomSheetTakeOver = gql`
  mutation CompleteBottomSheetTakeOver(
    $input: CompleteBottomSheetTakeOverInput!
  ) {
    completeBottomSheetTakeOver(input: $input) {
      __typename
      ... on CompleteBottomSheetTakeOverSuccess {
        id
        tile {
          __typename
          ... on VXLCardGroupTile {
            id
            status
            title
            allStepsCompleted
            tileType
          }
        }
      }
      ... on CompleteBottomSheetTakeOverError {
        code
        message
        title
      }
    }
  }
`;

export default CompleteBottomSheetTakeOver;
